import { HttpErrorResponse, HttpParams } from '@angular/common/http';
import * as moment from 'moment';
import { Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AppError } from '../../common/app-error';
import { Response } from '../../models/response.model';

export class CommonDataService {
  constructor(private endPoint: string) {}

  protected getFullUrl(resourceName: string,admin = false) {
    let url =`${environment.apiUrl}`;
    let endpoint = admin ? `admin/${this.endPoint}` : this.endPoint;
    if (endpoint)
    {
      url = `${url}/${endpoint}`
    }
    if (resourceName)
    {
      url  = `${url}/${resourceName}`
    }
    return url;
  }

  protected emitData(response: Response<any>): any {
    return response.data;
  }

  protected handleError(error: Error): Observable<never> {
    if (error instanceof HttpErrorResponse) {
      return throwError(() => new AppError(error.statusText));
    }
    return throwError(() => new AppError(error.message));
  }

  protected parseToFormData(object: any): FormData {
    if (object instanceof FormData)
    return object;

    const keys = Object.keys(object);
    const formData = new FormData();

    console.log('Parsing object to FormData:', object);
    console.log('Object keys:', keys);

    for (const key of keys) {
      if (object[key] instanceof moment) object[key] = object[key].format();

      if (object[key] instanceof Date) {
        object[key] = moment(object[key]).format('YYYY-MM-DD');
      }

      if (Array.isArray(object[key])) {
        formData.append(key, JSON.stringify(object[key]));
        continue;
      }

      // Handle File objects properly
      if (object[key] instanceof File) {
        formData.append(key, object[key]);
        console.log(`Added file to FormData: ${key}`, object[key]);
        continue;
      }

      if (object[key] !== null && typeof object[key] !== 'undefined') {
        formData.append(key, object[key]);
        console.log(`Added field to FormData: ${key} = ${object[key]}`);
      }
    }

    // Log the final FormData contents
    console.log('Final FormData contents:');
    // Log the original object that was used to create FormData
    const formDataObj: any = {};
    for (const key of keys) {
      if (object[key] !== null && typeof object[key] !== 'undefined') {
        formDataObj[key] = object[key];
      }
    }
    console.log('FormData object:', formDataObj);

    return formData;
  }

  protected parseToQueryStringParams(object: any): HttpParams {
    let params = new HttpParams();
    if (object) {
      const keys = Object.keys(object);
      for (const key of keys) {
        const property = object[key];

        if (!property && property !== '') continue;
        else {
          if (object[key] instanceof moment) {
            object[key] = property.format('YYYY-MM-DD');
          }

          if (object[key] instanceof Date) {
            object[key] = moment(property).format('YYYY-MM-DD');
          }

          if (Array.isArray(object[key])) {
            params = params.append(key, JSON.stringify(object[key]));
            continue;
          }

          params = params.append(key, object[key]);
        }
      }
    }
    return params;
  }
}
